<template>
    <div class="Active" v-if="isFinishLoading">
        <div class="container">
            <div class="partner-active">
                <div class="partner-successActive">
                    <img src="https://resource.rcclchina.com.cn/partner/activeIcon.png" title="激活图标">
                    <span>激活成功</span>
                </div>
                <div class="countDownReturn">
                    <span class="countDown">{{countDown}}</span><span>秒后自动返回首页</span>
                </div>
                
            
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "PartnerActive",
    data () {
        return {
            countDown: 5,
            isFinishLoading: false,
            countDownObj: null
        }
    },
    async beforeMount () {
        const activeToken = this.$router.currentRoute.query.activeToken
        if (!activeToken || activeToken.length == 0) {
            return this.$router.push({
                name: "PartnerIndex"
            })
        }
        await api.partner.active(activeToken)
        this.isFinishLoading = true
        this.countDownTimer()

    },
    methods: {
        countDownTimer () {
            this.countDownObj = setInterval(()=> {
                this.countDown--;
                if (this.countDown == 0) {
                    clearInterval(this.countDownObj);
                    this.$router.push({
                        name: "PartnerIndex"
                    })
                }
            }, 1000);
        }
    }
}
</script>

<style lang="less" scoped>
.partner-active {
    margin-bottom: 92px;
    .partner-successActive {
        margin-top: 81px;
        font-size: 0;
        text-align: center;
        img {
            width: 40px;
            height: 46px;
            vertical-align: middle;
        }
        span {
            margin-left: 20px;
            font-size: 30px;
            color: #1174b9;
            vertical-align: middle;
        }
    }
    .countDownReturn {
        text-align: center;
        font-size: 16px;
        margin-top: 20px;
        span {
            color: red;
        }
    }
}
</style>